import { ReactElement, lazy } from 'react';

import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';

import AppLayout from '@/components/layout/AppLayout';

import EAppRoute from '@/types/appRoutes';

import { DefaultPartnerRedirect, FormFlowRoutes } from './components';

const NotFoundLazy = lazy(() => import('@/pages').then((module) => ({ default: module.NotFound })));
const HomePageLazy = lazy(() => import('@/pages').then((module) => ({ default: module.HomePage })));

const AppRouter = (): ReactElement => {
	return (
		<>
			<BrowserRouter>
				<Routes>
					<Route element={<AppLayout />}>
						{process.env.DEFAULT_PARTNER ? (
							<>{FormFlowRoutes({ withoutPartnerSlug: true })}</>
						) : (
							<>
								<Route element={<HomePageLazy />} index />
							</>
						)}
						<Route element={<DefaultPartnerRedirect />}>{FormFlowRoutes({})}</Route>
						<Route element={<NotFoundLazy />} path={EAppRoute.NotFound} />
					</Route>
					<Route element={<Navigate to={EAppRoute.NotFound} replace />} path="*" />
				</Routes>
			</BrowserRouter>
		</>
	);
};

export default AppRouter;
